var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FormFieldRadioGroup',{attrs:{"checked":_vm.selectedVisualizationMode,"label":_vm.$t('Anzeige'),"variant":"vertical","options":_vm.options},on:{"input":(value) => _vm.$emit('update:selectedVisualizationMode', value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }